import logo from "./assets/generic2/logo.svg";
import background from "../../assets/background_.jpg";

/**
 * generic2 — a vendor-neutral clone of the `schmidt` skin.
 *
 * Purpose: demo the product with schmidt's presentation (blue/navy palette and,
 * crucially, `claimWizardFlow: "customer"` — the polished two-phase
 * customer→broker journey) without showing a real customer's name. Every
 * Schmidt company/tenant name is replaced by the neutral disphere naming from
 * `generic.js`; everything else is byte-for-byte schmidt.
 *
 * Keep in sync with `schmidt.js` when that skin changes — this file exists to
 * differ from it in NAMES ONLY.
 */
export default {
  id: "generic2",
  name: "Schadenportal",
  productName: "Schadenportal",

  // Footer: "<product> | Version x | <company>".
  footer: {
    productName: "disphere Schadenportal",
    companyName: "disphere interactive GmbH",
  },

  palette: {
    // Navy is pinned at the dark end so headings / deep surfaces match the dummy.
    primary: { seed: "#4A78BC", anchor: 700, overrides: { 900: "#1B2C45" } },
    secondary: { seed: "#4A78BC", anchor: 600, overrides: { 900: "#1B2C45" } },
  },

  // Same navy sidebar surface as schmidt.
  sidebar: { background: "#1B2C45" },

  // Contact block — drives the "Kontakt" modal.
  contact: {
    label: "Schadenportal",
    name: "",
    funktion: "Zentrale",
    telefon: "",
    fax: "",
    email: "",
  },

  // Short labels used inline in tables / claim detail.
  labels: {
    tenantName: "Schadenportal",
    short: "Schadenportal",
  },

  // `auth` omitted, as in schmidt — AuthLayout's fallbacks are the generic copy.
  // `typography` omitted → default Inter face.

  assets: {
    logo,
    logoAlt: "Schadenportal Logo",
    background,
    // schmidt omits this on purpose; here the disphere signet is the neutral
    // stand-in so the browser tab is not a real customer's mark either.
    favicon: "/disphere_favicon.png",
  },

  // Identical to schmidt — including the two-phase claim-report flow.
  features: {
    showSidebarTitle: true,
    help: true,
    userDisplay: "sidebar",
    claimWizardFlow: "customer",
    nav: {
      claims: true,
      contracts: true,
      mail: true,
      customers: true,
      insurers: true,
      objects: true,
      controlling: true,
      users: true,
      substitutions: true,
      reminders: true,
      bookings: true,
    },
  },
};
